const currentYear = new Date().getFullYear();

const locale = {
    code: "ar",
    label: "العربية",
    NAV_BAR: {
        home: "الرئيسية",
        homeId: "home",
        aboutus: "من نحن",
        aboutId: "aboutus",
        faq: "الأسئلة",
        faqId: "faq-section",
        contact: "اتصل",
        contactId: "contact-section",
        button: "الحصول على وصول مبكر",
    },

    HERO: {
        heroHeading: "قائمتك متاحة فورًا",
        heroParagraph:
            "أنشئ وقم بتحديث ومشاركة قائمتك باستخدام رمز QR واحد — بدون عناء، دون إعادة طباعة.",
        button: "الحصول على وصول مبكر",
        downloadText: "تحميل على",
        appStore: "App Store",
        getItOn: "GET IT ON",
        googlePlay: "Google Play",
    },

    SERVICES: {
        heading: "خدماتنا",
        cards: [
            {
                title: "إنشاء ورفع القائمة",
                description:
                    "قم بإنشاء قائمةك ورفعها بسهولة في دقائق! أضف العناصر، حدد الأسعار، وقم بتحديث التفاصيل دون الحاجة لمهارات تقنية.",
            },
            {
                title: "تحديث القائمة",
                description:
                    "قم بتحديث قائمتك في الوقت الفعلي في أي وقت وأي مكان! غيّر الأسعار، أضف وجبات جديدة أو أرشِف العناصر غير المتاحة فورًا دون إعادة طباعة.",
            },
            {
                title: "إنشاء ومشاركة",
                description:
                    "قم بإنشاء رمز QR فريد لقائمتك على الفور! شاركه على الطاولات أو الملصقات أو عبر الإنترنت لتمكين العملاء من مسح الرمز والوصول إلى أحدث قائمة.",
            },
        ],
    },

    FEATURES: {
        heading: "استكشف ميزاتنا المذهلة",
        lists: [
            {
                title: "إدارة القائمة",
                description:
                    "قم بإدارة قائمتك في أي وقت! أضف أو حرر أو احذف العناصر بسهولة للحفاظ على عرضك محدثًا.",
            },
            {
                title: "رؤى وتقارير",
                description:
                    "احصل على رؤى قيمة مع التقارير الفورية! تتبّع مشاهدات القائمة، ومسح رموز QR، وتفاعل العملاء.",
            },
            {
                title: "مشاركة رموز QR",
                description:
                    "شارك قائمتك برمز QR فريد! اعرضه على الطاولات أو الملصقات أو عبر الإنترنت ليتمكن العملاء من الوصول إليه فورًا.",
            },
            {
                title: "مراجعات العملاء",
                description:
                    "اعرض تعليقات العملاء الحقيقية والتقييمات! عزز الثقة، وطور قائمتك، وحسّن تجربة الضيوف.",
            },
            {
                title: "عروض وخصومات",
                description:
                    "زد مبيعاتك بعروض خاصة وخصومات! أبرز الترويجات لفترة محدودة والصفقات الحصرية.",
            },
        ],
    },

    ABOUT: {
        heading: "حول My QR Menu",
        headingPara: "بسّط إدارة قائمة مطعمك مع التحديثات الفورية.",
        highlightHeading: "الوصول السريع والسهل إلى كل ما تحتاجه",
        highlightPara: "جميع ميزات قائمتك — بنقرة واحدة فقط.",
        cards: {
            left: {
                heading: ["أضف المكونات بسهولة", "إلى قائمة QR الخاصة بك"],
                alt: "إضافة مكونات",
            },
            right: {
                heading: ["الوصول إلى لوحة", "قائمة الطعام بسهولة"],
                alt: "لوحة القائمة",
            },
        },
    },

    FAQ: {
        heading: "لديك أسئلة. لدينا الإجابات.",
        subheading: "كل ما تحتاج لمعرفته عن المنتج.",
        items: [
            {
                question: "ما هو My QRMenu؟",
                answer:
                    "My QRMenu هو منصة قائمة رقمية تتيح للمطاعم إنشاء وتحديث ومشاركة قوائمها على الفور باستخدام رموز QR.",
            },
            {
                question: "هل يمكنني تحديث قائمتي بعد إنشائها؟",
                answer:
                    "نعم، يمكنك تحديث قائمتك في أي وقت وستظهر على الفور عندما يقوم العملاء بمسح رمز QR الخاص بك.",
            },
            {
                question: "كيف يعمل My QRMenu؟",
                answer:
                    "تنشئ قائمة، تنشئ رمز QR، ويقوم العملاء بمسحه لمشاهدة أحدث إصدار من قائمتك.",
            },
            {
                question: "كيف أشارك رمز QR الخاص بي؟",
                answer:
                    "يمكنك مشاركة رمز QR رقميًا أو طباعته لعرضه في مطعمك.",
            },
            {
                question: "هل My QRMenu ملائم للهاتف؟",
                answer:
                    "نعم، تم تحسين My QRMenu لجميع الأجهزة، بما في ذلك الهواتف المحمولة والأجهزة اللوحية.",
            },
            {
                question: "هل يمكنني جمع تقييمات العملاء؟",
                answer:
                    "نعم، يمكنك تمكين تقييمات العملاء واستخدام الملاحظات لتحسين عروضك.",
            },
        ],
    },

    CONTACT: {
        heading: "اتصل بنا",
        subheading: "فريقنا الودود يتطلع لسماعك.",
        firstName: "الاسم الأول",
        lastName: "اسم العائلة",
        email: "البريد الإلكتروني",
        message: "الرسالة",
        firstNamePlaceholder: "الاسم الأول",
        lastNamePlaceholder: "اسم العائلة",
        emailPlaceholder: "أنت@شركة.com",
        messagePlaceholder: "اكتب رسالتك...",
        privacyConsent: "أنت توافق على",
        privacyPolicy: "سياسة الخصوصية",
        submitButton: "إرسال الرسالة",
        toast: {
            requiredConsent: "يجب أن توافق على سياسة الخصوصية.",
            submitting: "جارٍ إرسال الرسالة...",
            success: "تم إرسال الرسالة بنجاح!",
            fail: "فشل إرسال الرسالة. حاول مرة أخرى.",
            error: "حدث خطأ. يرجى التحقق من الاتصال.",
        },
    },

    HELP_PAGE: {
        title: "مركز المساعدة",
        description: "إذا كان لديك أي أسئلة أو تحتاج إلى مساعدة، يرجى الاتصال بنا على ",
        contactEmail: "contact@myqrmenu.co",
        faqPrompt: "أو راجع الأسئلة المتداولة أدناه، فقد تجد ما تبحث عنه.",
    },

    FOOTER: {
        footerHeading: "قوائم رقمية سلسة، مبسطة!",
        footerButton: "انضم إلى قائمة الانتظار",
        footerConnect: "تواصل معنا",
        footerTerms: "الشروط والاتفاقيات",
        footerHelp: "مركز المساعدة",
        footerPrivacy: "سياسة الخصوصية",
        footerCopyright: `©${currentYear} جميع الحقوق محفوظة.`,
    },

    PRIVACY_POLICY: {
        title: "سياسة الخصوصية",
        lastUpdated: "آخر تحديث: 22 مايو 2025",
        content: `
            <article class="mb-12">
                <p class="mb-6 leading-relaxed">
                تصف سياسة الخصوصية هذه سياساتنا وإجراءاتنا المتعلقة بجمع معلوماتك واستخدامها والكشف عنها عند استخدام الخدمة وتخبرك بحقوق الخصوصية الخاصة بك وكيف يحميك القانون.
                </p>
                <p class="mb-6 leading-relaxed">
                نحن نستخدم بياناتك الشخصية لتوفير الخدمة وتحسينها. باستخدامك للخدمة، فإنك توافق على جمع واستخدام المعلومات وفقًا لسياسة الخصوصية هذه.
                </p>
            </article>

            <section class="mb-12">
                <header class="mb-6">
                <h2 class="text-2xl font-semibold">التفسير والتعاريف</h2>
                </header>
                <article class="mb-8">
                <h3 class="text-xl font-semibold mb-2">التفسير</h3>
                <p class="mb-6 leading-relaxed">
                الكلمات التي تبدأ بحرف كبير لها معانٍ محددة بموجب الشروط التالية. التعاريف التالية لها نفس المعنى بغض النظر عما إذا كانت تظهر في صيغة المفرد أو الجمع.
                </p>
                </article>

                <article>
                <h3 class="text-xl font-semibold mb-4">التعاريف</h3>
                <ul class="list-disc list-inside mb-6 space-y-3 text-gray-800">
                    <li><strong>الحساب</strong> يعني حسابًا فريدًا تم إنشاؤه لك للوصول إلى خدمتنا.</li>
                    <li><strong>الشركة</strong> تشير إلى <strong>My QR Menu،</strong> لندن، المملكة المتحدة.</li>
                    <li><strong>ملفات تعريف الارتباط</strong> هي ملفات صغيرة يتم وضعها على جهاز الكمبيوتر الخاص بك.</li>
                    <li><strong>البيانات الشخصية</strong> هي أي معلومات تتعلق بفرد محدد أو يمكن تحديده.</li>
                    <li><strong>الخدمة</strong> تشير إلى الموقع الإلكتروني.</li>
                    <li><strong>أنت</strong> يعني الفرد الذي يصل إلى الخدمة أو يستخدمها.</li>
                </ul>
                </article>
            </section>

            <section class="mb-12">
                <h2 class="text-2xl font-semibold mb-6">اتصل بنا</h2>
                <p>
                إذا كانت لديك أي أسئلة حول سياسة الخصوصية هذه، يمكنك الاتصال بنا:
                </p>
                <ul class="list-disc list-inside mt-2">
                <li>عبر البريد الإلكتروني: <a href="mailto:hello@myqrmenu.co" class="text-gray-800 underline">hello@myqrmenu.co</a></li>
                </ul>
            </section>
        `
    },

    TERMS_AND_CONDITIONS: {
        title: "الشروط والأحكام",
        lastUpdated: "آخر تحديث: 22 مايو 2025",
        content: `
            <p class="leading-relaxed mb-6">
            يرجى قراءة هذه الشروط والأحكام بعناية قبل استخدام تطبيقنا أو موقعنا الإلكتروني.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">1. التفسير والتعاريف</h2>
            <h3 class="text-xl font-semibold mt-6 mb-2">التفسير</h3>
            <p class="leading-relaxed mb-4">
            الكلمات التي تبدأ بحرف كبير لها معانٍ محددة بموجب الشروط التالية.
            </p>
            <h3 class="text-xl font-semibold mt-6 mb-2">التعاريف</h3>
            <ul class="list-disc list-inside mb-6 leading-relaxed text-gray-800">
            <li><strong>التطبيق</strong> يعني البرنامج المقدم من My QR Menu.</li>
            <li><strong>الشركة</strong> تشير إلى My QR Menu، ومقرها لندن، المملكة المتحدة.</li>
            <li><strong>الخدمة</strong> تشير إلى التطبيق والموقع الإلكتروني.</li>
            <li><strong>أنت</strong> يعني الفرد أو الشركة التي تصل إلى الخدمة.</li>
            </ul>

            <h2 class="text-2xl font-semibold mt-10 mb-4">2. الإقرار</h2>
            <p class="leading-relaxed mb-6">
            من خلال الوصول إلى الخدمة أو استخدامها، فإنك توافق على الالتزام بهذه الشروط. إذا كنت لا توافق على أي جزء منها، فلا يمكنك الوصول إلى الخدمة.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">3. الروابط بمواقع ويب أخرى</h2>
            <p class="leading-relaxed mb-6">
            قد تحتوي خدمتنا على روابط لمواقع ويب تابعة لجهات خارجية. نحن لا نتحمل المسؤولية عن محتواها أو ممارساتها.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">4. الإنهاء</h2>
            <p class="leading-relaxed mb-6">
            نحتفظ بالحق في إنهاء أو تعليق وصولك إلى الخدمة فورًا، دون إشعار مسبق، لأي سبب كان.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">5. تحديد المسؤولية</h2>
            <p class="leading-relaxed mb-6">
            إلى أقصى حد يسمح به القانون، لن تتحمل الشركة المسؤولية عن أي أضرار ناتجة عن استخدامك للخدمة.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">6. إخلاء المسؤولية "كما هي" و "كما هي متوفرة"</h2>
            <p class="leading-relaxed mb-6">
            يتم تقديم الخدمة لك على أساس "كما هي" و "كما هي متوفرة". نحن لا نضمن أنها ستكون خالية من الأخطاء أو دون انقطاع.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">7. القانون الحاكم</h2>
            <p class="leading-relaxed mb-6">
            تخضع هذه الشروط لقوانين المملكة المتحدة.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">8. حل النزاعات</h2>
            <p class="leading-relaxed mb-6">
            إذا كان لديك نزاع معنا، فإنك توافق على محاولة حله بشكل غير رسمي قبل اتخاذ أي إجراء قانوني.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">9. لمستخدمي الاتحاد الأوروبي (EU)</h2>
            <p class="leading-relaxed mb-6">
            إذا كنت مستهلكًا في الاتحاد الأوروبي، فأنت تستفيد من الأحكام الإلزامية لقانون بلد إقامتك.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">10. الامتثال القانوني في الولايات المتحدة</h2>
            <p class="leading-relaxed mb-6">
            أنت تقر وتضمن أنك لست مقيمًا في بلد يخضع لعقوبات من حكومة الولايات المتحدة.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">11. القابلية للفصل والتنازل</h2>
            <h3 class="text-xl font-semibold mt-6 mb-2">القابلية للفصل</h3>
            <p class="leading-relaxed mb-4">
            إذا تبين أن أي نص من هذه الشروط غير قابل للتنفيذ، فإن النصوص المتبقية تظل سارية المفعول.
            </p>
            <h3 class="text-xl font-semibold mt-6 mb-2">التنازل</h3>
            <p class="leading-relaxed mb-6">
            الفشل في إنفاذ أي نص لا يشكل تنازلاً عن هذا الحق.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">12. تفسير الترجمة</h2>
            <p class="leading-relaxed mb-6">
            قد تكون هذه الشروط قد تمت ترجمتها. في حالة حدوث نزاع، تسود النسخة الإنجليزية.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">13. التغييرات على هذه الشروط</h2>
            <p class="leading-relaxed mb-6">
            قد نقوم بتحديث هذه الشروط في أي وقت. سنخطرك عن طريق نشر إشعار على موقعنا.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">14. اتصل بنا</h2>
            <p class="leading-relaxed mb-2">إذا كانت لديك أسئلة حول هذه الشروط، يمكنك الاتصال بنا:</p>
            <ul class="list-disc list-inside text-gray-800">
            <li>عبر البريد الإلكتروني: <a href="mailto:hello@myqrmenu.co" class="text-blue-600 underline">hello@myqrmenu.co</a></li>
            </ul>
        `
    }
};

export default locale;
